require('./_cdek');

window.VegasCatalog.Order = {
	make: function ($form, callback) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$.post(route, params, function (data) {
			if (callback) {
				callback(data);
			}
		})
	},
};

$(document).ready(function () {
	let $formOrder = $("#form-cart");

	$formOrder.find('[name=delivery_id]').on('change', function () {
		let id = $(this).attr('id'),
			val = parseInt($(this).val()),
			$containerOrder = $(this).closest('.cart-form'),
			$containerDelivery = $containerOrder.find('.delivery-area--placement');

		// set show & active
		$containerDelivery.find('.active').removeClass('show active');
		let $currentDelivery = $containerDelivery.find('[data-id=' + id + ']');
		$currentDelivery.addClass('show active');

		// use required
		$('.delivery-area--placement .toggle-required').removeAttr('required');
		$currentDelivery.find('.toggle-required').attr('required', 'required');

		VegasCatalog.Cart.updateTotalAll();
	});

	let intervalPromocode;
	$formOrder.find('[name=promocode]').on('keydown', function () {
		clearInterval(intervalPromocode);
		intervalPromocode = setTimeout(function () {
			VegasCatalog.Cart.updateTotalAll();
		}, 200);
	});

	$formOrder.submit(function () {
		$('.catalog-cart--preload').addClass('show');

		VegasCatalog.Order.make($formOrder, function (data) {
			if (data.error) {
				$('.catalog-cart--preload').removeClass('show')
				alert(data.msg);
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	let isYaMaps = true;
	try { if (ymaps) isYaMaps = true; } catch(e) { isYaMaps = false; }

	if (isYaMaps) {
		if (document.getElementById('user_address_cdek_courier')) {
			// cdek courier
			ymaps.ready(function () {
				let cdekCourierAddr = new ymaps.SuggestView('user_address_cdek_courier');

				cdekCourierAddr.events.add('select', function (e) {
					ymaps.geocode(e.get('item').value).then(function (res) {
						VegasCatalog.Cart.updateTotalAll(function (data) {
							if (typeof data.sums !== 'undefined') {
								$('.delivery-cdek-courier')
									.find('.sum')
									.text('Стоимость доставки: ' + output_roubles(data.sums.sum_delivery))
									.show()
								;
							}
						});
					});
				});
			});
		}
	}

	$('[name=user_address_cdek_courier]').keyup(function () {
		$('.delivery-cdek-courier').find('.sum').hide();
	});

	$formOrder.on("keydown", function (event) {
		return event.key != "Enter";
	});
});
